export const LANDING = '/clash';



// WEBPACK FOOTER //
// ./src/constants/routes.js